// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mchp-faq-subtitle[data-v-b0ca3388] {\n  margin-top: 3rem;\n  margin-bottom: 2rem;\n  font-weight: 600;\n}\n.mchp-faq-subtitle > a[data-v-b0ca3388] {\n    font-weight: normal;\n    color: #000;\n    text-decoration: underline;\n}\n.mchp-faqEmpty[data-v-b0ca3388] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  font-size: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
